if (!customElements.get('product-form')) {
  let globalEventsAdded = false;
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.inputId = this.form.querySelector('[name="id"]');
        this.inputId.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.chooseSize = this.querySelector('.card__choose-size');
        this.drawer = this.querySelector('.card__drawer');
        this.closeDrawer = this.querySelector('.card__drawer-close');
        this.variantButtons = this.querySelectorAll('.card__drawer-variant:not(.card__drawer-variant--oos)');
        if (this.chooseSize && this.drawer) {
          if (!globalEventsAdded) {
            this.addGlobalEventListeners();
            globalEventsAdded = true;
          }

          this.chooseSize.addEventListener('click', () => {
            const isExpanded = this.chooseSize.getAttribute('aria-expanded');
            if (isExpanded === 'false') {
              this.closeAnyOpenDrawer();
              this.openDrawer();
            } else {
              this.submitButton.click();
              this.collapseDrawer();
            }
          });
        }
        if (this.closeDrawer) {
          this.closeDrawer.addEventListener('click', () => {
            this.collapseDrawer();
          });
        }
        if (this.variantButtons.length) {
          this.variantButtons.forEach(button => {
            button.addEventListener('click', () => {
              const variantId = button.getAttribute('data-variant-id');
              if (variantId) {
                this.selectVariant(variantId);
              }
            });
          });
        }

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      addGlobalEventListeners() {
        // Close drawer on Escape key press
        document.addEventListener('keydown', (event) => {
          if (event.key === 'Escape') {
            this.closeAnyOpenDrawer();
          }
        });

        // Close drawer on scroll
        window.addEventListener('scroll', () => {
          this.closeAnyOpenDrawer();
        });
    
        // Close drawer if clicked outside of any open drawer
        document.addEventListener('click', (event) => {
          const openDrawer = document.querySelector('.card__drawer[aria-hidden="false"]');
          if (!openDrawer) {
            return;
          }
          const chooseSize = openDrawer.previousElementSibling;
          if (openDrawer && chooseSize && !openDrawer.contains(event.target) && event.target !== chooseSize) {
            this.closeAnyOpenDrawer();
          }
        });
      }

      closeAnyOpenDrawer() {
        const openDrawer = document.querySelector('.card__drawer[aria-hidden="false"]');
        if (openDrawer) {
          const relatedButton = openDrawer.closest('form').querySelector('.card__choose-size');
          if (relatedButton) {
            relatedButton.setAttribute('aria-expanded', 'false');
          }
          openDrawer.style.maxHeight = 0;
          openDrawer.setAttribute('aria-hidden', 'true');
        }
      }

      openDrawer() {
        this.chooseSize.setAttribute('aria-expanded', 'true');
        this.drawer.style.maxHeight = `${this.drawer.scrollHeight + 2}px`;
        this.drawer.setAttribute('aria-hidden', 'false');
      }

      collapseDrawer() {
        this.chooseSize.setAttribute('aria-expanded', 'false');
        this.drawer.setAttribute('aria-hidden', 'true');
        this.drawer.style.maxHeight = 0;
      }

      selectVariant(id) {
        this.variantButtons.forEach(button => {
          button.classList.remove('card__drawer-variant--active');
          const variantId = button.getAttribute('data-variant-id');
          if (id === variantId) {
            button.classList.add('card__drawer-variant--active');
            return;
          }
        });
        this.inputId.value = id;
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        if (this.querySelector('.loading__spinner')) this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');

            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            if (this.querySelector('.loading__spinner')) this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
